"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Border = function Border(_ref) {
  var theme = _ref.theme,
      bounds = _ref.bounds,
      hatched = _ref.hatched,
      hidden = _ref.hidden;
  var pattern;
  if (hidden) return null;

  if (hatched) {
    pattern = /*#__PURE__*/_react.default.createElement("pattern", {
      id: "diagonalHatch",
      width: "5",
      height: "5",
      patternTransform: "rotate(45 0 0)",
      patternUnits: "userSpaceOnUse"
    }, /*#__PURE__*/_react.default.createElement("line", {
      x1: "0",
      y1: "0",
      x2: "0",
      y2: "5",
      stroke: theme.default,
      strokeWidth: "2",
      strokeOpacity: "0.1"
    }));
  }

  return /*#__PURE__*/_react.default.createElement("g", null, pattern, /*#__PURE__*/_react.default.createElement("rect", {
    x: bounds.x.min,
    y: bounds.y.min,
    fill: hatched ? 'url(#diagonalHatch)' : 'transparent',
    strokeWidth: 2,
    stroke: theme.default,
    strokeOpacity: "0.1",
    height: bounds.y.max - bounds.y.min,
    width: bounds.x.max - bounds.x.min
  }));
};

Border.propTypes = {
  bounds: _propTypes.default.shape({
    x: _propTypes.default.number.isRequired,
    y: _propTypes.default.number.isRequired
  }).isRequired,
  hatched: _propTypes.default.bool,
  hidden: _propTypes.default.bool
};
Border.defaultProps = {
  hatched: false,
  hidden: false
};

var _default = (0, _styledComponents.withTheme)(Border);

exports.default = _default;
//# sourceMappingURL=Border.js.map